import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
function loadFBX() {
}
loadFBX.prototype = {
  constructor: loadFBX,
  //加载模型
  load: function (modelPath, mapsPath, progressCallBack,loadObjectFinishCallback) {
    const fbxLoader = new FBXLoader();
    fbxLoader.load(
      modelPath,
      (object) => {
        loadObjectFinishCallback(object)
      },
      (xhr) => {
        progressCallBack(xhr);
      },
      (error) => {
        console.log(error);
      }
    );
  },
}
export {
  loadFBX
}